import "../Errors.scss";
import auth from "../../../user/services/Auth";
import FloatingMessageLayout from "../../layouts/FloatingMessageLayout";
import LogoHeaderCard from "../../cards/LogoHeaderCard";
import Translate from "lang/Translate";

const Unauthorized = () => (
    <FloatingMessageLayout>
        <LogoHeaderCard loading={false}>
            <div data-testid="unauth" className="error_center_content" key="logoutcontent">
                <Translate text="unauthorized" />
            </div>
            <button
                data-testid="unauth-btn"
                onClick={() => {
                    auth.logout();
                }}
                className="button is-primary is-fullwidth"
            >
                <span>
                    <Translate text="sign_out" />
                </span>
            </button>
        </LogoHeaderCard>
    </FloatingMessageLayout>
);
export default Unauthorized;
